import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    checkAddress: 'The address on the document is',
    checkDate:
      'It dates back to less than three months (issued after {formattedDateThreeMonthsAgo})',
    checkHostName:
      'The name on the document is the same as the one on your host’s ID',
    checkLandline: 'The document is not a mobile phone bill',
    checkName: 'The name on the document is',
    checkOwnName: 'The name on the document is your name',
    checkQuality: 'The document is readable and is not cropped',
    description: 'Please check the information:',
    firstNameLabel: 'First name:',
    lastNameLabel: 'Last name:',
    title: 'Proof of address verification',
    valid: 'The document is not a cancellation or unpaid bill',
  },
  fr: {
    checkAddress: 'L’adresse est bien la suivante\u00A0:',
    checkDate:
      'Le document est daté de moins de 3 mois (émis après le {formattedDateThreeMonthsAgo})',
    checkHostName:
      'Le nom sur le document est le même que celui sur la pièce d’identité de votre hébergeur',
    checkLandline: 'Le document n’est pas une facture de téléphone mobile',
    checkName: 'Le prénom et le nom sont bien les suivants\u00A0:',
    checkOwnName: 'Le prénom et le nom sont bien les vôtres',
    checkQuality: 'Le document est lisible et n’est pas rogné',
    description: 'Veuillez vérifier les informations\u00A0:',
    firstNameLabel: 'Prénom\u00A0:',
    lastNameLabel: 'Nom\u00A0:',
    title: 'Vérification du justificatif de domicile',
    valid: 'Le document n’est pas une facture de résiliation ou d’impayé',
  },
});

export default locales;
